export default "__VITE_ASSET__Cq4G644U__"